"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentWebViewerProvider = exports.DocumentWebViewerContext = exports.DocumentWebViewerContextDefaults = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
exports.DocumentWebViewerContextDefaults = {
    setInstance: function () { return undefined; },
    instance: undefined,
};
/**
 * Context used to share DocumentWebViewer instance and actions
 */
exports.DocumentWebViewerContext = react_1.default.createContext(exports.DocumentWebViewerContextDefaults);
/**
 * Provides DocumentWebViewerContext to child components
 */
var DocumentWebViewerProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.default.useState(), instance = _b[0], setInstance = _b[1];
    var value = react_1.default.useMemo(function () { return ({
        instance: instance,
        setInstance: setInstance,
    }); }, [instance, setInstance]);
    return ((0, jsx_runtime_1.jsx)(exports.DocumentWebViewerContext.Provider, __assign({ value: value }, { children: children })));
};
exports.DocumentWebViewerProvider = DocumentWebViewerProvider;
